import { ScreenLink } from '@gogame/screens';
import { partnerCompaniesDetailsLink } from 'scenes/PartnerCompanies/navigation';
import React from 'react';

export const PartnerCompanyDetailsLink = ({ children, row }) => (
  <ScreenLink
    link={partnerCompaniesDetailsLink}
    pathParams={{
      id: row.id,
    }}
  >
    {children}
  </ScreenLink>
);
